module.exports = __webpack_public_path__ + "img/ico-trash-gray.cf6702d2.svg";